import {
  LayoutDashboardIcon,
  PlayCircleIcon,
  ScaleIcon,
  ZapIcon,
} from "lucide-react";
import { toTitleCase } from "@/lib/utils";

export type ActionData = {
  type: string;
  analysis_title?: string;
  analysis_id?: string;
  rule_set_name?: string;
  rule_set_id?: string;
};

export function ActionIcon({
  type,
  className = "h-3.5 w-3.5",
}: {
  type: string;
  className?: string;
}) {
  switch (type) {
    case "run_analysis":
      return <PlayCircleIcon className={className} />;
    case "evaluate_rules":
      return <ScaleIcon className={className} />;
    case "create_dashboard_widget":
      return <LayoutDashboardIcon className={className} />;
    default:
      return <ZapIcon className={className} />;
  }
}

export function ActionLabel({ action }: { action: ActionData }) {
  switch (action.type) {
    case "run_analysis":
      return (
        <>
          <span className="font-medium">Run analysis:</span>{" "}
          <span className="text-muted-foreground">
            {action.analysis_title || action.analysis_id || "Analysis"}
          </span>
        </>
      );
    case "evaluate_rules":
      return (
        <>
          <span className="font-medium">Evaluate rules:</span>{" "}
          <span className="text-muted-foreground">
            {action.rule_set_name || action.rule_set_id || "Rules"}
          </span>
        </>
      );
    case "create_dashboard_widget":
      return <span className="font-medium">Create dashboard widget</span>;
    default:
      return (
        <span className="text-muted-foreground">{toTitleCase(action.type)}</span>
      );
  }
}

export function CompactActionLabel({ action }: { action: ActionData }) {
  switch (action.type) {
    case "run_analysis":
      return (
        <span className="truncate">
          {action.analysis_title || action.analysis_id || "Analysis"}
        </span>
      );
    case "evaluate_rules":
      return (
        <span className="truncate">
          {action.rule_set_name || action.rule_set_id || "Rules"}
        </span>
      );
    case "create_dashboard_widget":
      return <span>Dashboard widget</span>;
    default:
      return <span>{toTitleCase(action.type)}</span>;
  }
}
